<div id="wrapper">


  <div id="left">
    <ngx-spinner bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547" type="ball-clip-rotate-multiple"
      [fullScreen]="true">
      <p style="color: white"> </p>
    </ngx-spinner>

    <div id="signin">
      <div class="logo">
        <img src="../../assets//core-img/LogoLogin.png"  class="img-fluid" alt="" />


      </div>

      <form *ngIf="resetFormShow==false" [formGroup]="loginForm" (ngSubmit)="onSubmit()">

        <div class="input-group">
          <div style="background-color: #257aba;    padding: 3px;" class="input-group-addon">
 
          </div>

        <input placeholder="Nom d'utilisateur" type="text" formControlName="username" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />

          </div>
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
          <div *ngIf="f.username.errors.required">Nom d'utilisateur est obligatoire</div>
        </div>
<br>
<div class="input-group">
  <div style="background-color: #257aba;    padding: 3px;" class="input-group-addon">

  </div>
        <input placeholder="Mot de passe" type="password" formControlName="password" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
          </div>
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <div *ngIf="f.password.errors.required"  >le mot de passe est obligatoire</div>
        </div>

        <button class="primary-btn mt-5"> Connexion</button>
        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>

      </form>

      <form class="animated fadeInDown" *ngIf="resetFormShow==true" [formGroup]="resetForm"
        (ngSubmit)="onResetPassword()">
        <div class="input-group">
          <div style="background-color: #257aba;    padding: 3px;" class="input-group-addon">
        
          </div>
        <input placeholder="Nom d'utilisateur ou Email" type="text" formControlName="user_input" class="form-control"
          [ngClass]="{ 'is-invalid': submittedResetForm && r.user_input.errors }" />
          </div>
        <div *ngIf="submittedResetForm && r.user_input.errors" class="invalid-feedback">
          <div *ngIf="r.user_input.errors.required">Nom d'utilisateur est obligatoire</div>

        </div>


        <div style="display: none;">

          <input type="text" formControlName="redirectTo" id="redirectTo" [(ngModel)]="RedirectURL" />

        </div>




        <button class="primary-btn mt-4"> Réinitialiser le mot de passe </button>
        <div *ngIf="showerror ==500" class="alert alert-danger mt-3 mb-0" aria-label="Close">{{messageErrorReset}}
        </div>
        <div *ngIf="showerror == 200" class="alert alert-success mt-3 mb-0" aria-label="Close">
          {{messageSuccessReset}}
        </div>
        <button (click)="ReturnButtonSignIn()" class="primary-btn mt-4 d-flex justify-content-center">
          <mat-icon style="color: white;">keyboard_return</mat-icon> Retour
        </button>

      </form>


      <div *ngIf="resetFormShow==false" class="links">
        <a style="color: #257aba"  (click)=" resetPassword()">Mot de passe oublié</a>

      </div>
      <!-- <div *ngIf="resetFormShow==false" class="or">
        <hr class="bar" />
        <span>OR</span>
        <hr class="bar" />
      </div>
      <ngx-qrcode *ngIf="resetFormShow==false" [elementType]="elementType" [errorCorrectionLevel]="correctionLevel"
        [value]="value" cssClass="bshadow"></ngx-qrcode>
    </div>
    <footer id="main-footer">
      <p>Copyright &copy; 2020, Stg drive All Rights Reserved</p>
      <ngx-qrcode *ngIf="resetFormShow==false"
  [elementType]="elementType"
  [errorCorrectionLevel]="correctionLevel"
  [value]="value"
  cssClass="bshadow"></ngx-qrcode> -->
    </div>
    <footer id="main-footer">
      <p>Copyright &copy; 2020, Stg drive Tous droits réservés</p>
      <div>
        <a href="https://www.stg.ma/STG-notion_de_confidentialit%C3%A9.pdf" style="color: #257aba">Politique de confidentialité</a>
      </div>
    </footer>
  </div>
  <div id="right">

    <div class="untitled">
<div class="untitled__slides">
        <div class="untitled__slide" >
       
          <div class="untitled__slideContent" >
         
            <br>
            <a class="button" href="https://www.stg.ma/site2/solutions" target="/black">Découvrez nos solutions</a>
          </div>
        </div>
    </div>
</div>

  </div>